import { Link } from "react-router-dom";

export default function NavHome() {
    return (
        <div className="flex flex-col items-center justify-center min-h-[75vh] text-center px-6">

            {/* Small Label */}
            <p className="hero-enter hero-enter-delay-1 uppercase tracking-[0.5em] text-zinc-300 text-sm font-light">
                Cebu City • Philippines
            </p>

            {/* Title */}
            <h1
                className="
                    mt-6
                    font-bold
                    text-white
                    text-5xl
                    lg:text-7xl
                    xxl:text-8xl
                    drop-shadow-[0_5px_20px_rgba(0,0,0,.9)]
                    hero-enter
                    hero-enter-delay-2
                "
            >
                QUILATON LAW OFFICE
            </h1>

            {/* Divider */}
            <div className="hero-enter hero-enter-delay-2 mt-8 h-px w-28 bg-gradient-to-r from-transparent via-zinc-300 to-transparent" />

            {/* Subtitle */}
            <h2
                className="
                    mt-8
                    text-3xl
                    lg:text-5xl
                    font-light
                    text-zinc-100
                    drop-shadow-[0_4px_12px_rgba(0,0,0,.9)]
                    hero-enter
                    hero-enter-delay-3
                "
            >
                Promptness meets competence
            </h2>

            {/* Description */}
            <p
                className="
                    mt-8
                    max-w-3xl
                    leading-8
                    text-zinc-200
                    drop-shadow-[0_2px_8px_rgba(0,0,0,.9)]
                    hero-enter
                    hero-enter-delay-3
                "
            >
                An all-specialization and independent law firm in Cebu City,
                Philippines that offers a wide range of legal services.
                Our law firm places a premium on competence, integrity, and
                professionalism to ensure maximum satisfaction among our
                clients. With years of service in the legal industry, we
                continuously and passionately expand our presence both locally
                and internationally.
            </p>

            {/* Buttons */}
            <div className="hero-enter hero-enter-delay-4 mt-12 flex items-center gap-5">

                <a
                    href="https://facebook.com/quilatonlawoffice"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="
                        flex
                        h-14
                        w-14
                        items-center
                        justify-center
                        rounded-full
                        border
                        border-zinc-400/70
                        text-white
                        backdrop-blur-sm
                        transition-all
                        duration-300
                        hover:border-white
                        hover:bg-white/10
                    "
                >
                    f
                </a>

                <a
                    href="https://linkedin.com/in/atty-abelardo-quilaton-jr-5a3b25248/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="
                        flex
                        h-14
                        w-14
                        items-center
                        justify-center
                        rounded-full
                        border
                        border-white/20
                        bg-black/25
                        backdrop-blur-md
                        text-white
                        transition-all
                        duration-300
                        hover:bg-black/40
                        hover:border-white/50
                        hover:scale-105
                        hover:shadow-[0_0_15px_rgba(255,255,255,0.08)]
                    "
                >
                    in
                </a>

                <Link
                    to="/contact/"
                    className="
                        group
                        rounded-xl
                        border
                        border-white/30
                        bg-gradient-to-b
                        from-black/40
                        to-black/20
                        backdrop-blur-md
                        px-9
                        py-4
                        text-white
                        tracking-[0.15em]
                        transition-all
                        duration-300
                        hover:from-black/60
                        hover:to-black/40
                        hover:border-white/60
                        hover:shadow-[0_0_25px_rgba(255,255,255,0.2)]
                        hover:-translate-y-0.5
                    "
                >
                    CONTACT US
                </Link>

            </div>

        </div>
    );
}
